<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

import VistosBuenos from "../graficos/VistosBuenos.vue";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
  components: { VistosBuenos },
  props: {
    data: Object,
    vistos_buenos: {
      type: Object,
      required: false,
    },
    irVistosBuenos: Function,
  },
  data() {
    return {
      chartOptions: {
        legend: {
          show: true,
          position: "bottom",
        },
        chart: {
          width: 100,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
        },
        labels: [],
        responsive: [
          {
            breakpoint: 430,
            options: {
              chart: {
                width: 100,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    series() {
      return Object.values(this.data ?? {});
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newVal) {
        const labels = Object.keys(newVal ?? {});

        this.chartOptions.labels = labels;
      },
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col gap-4 p-4 border-primary border-[1px] rounded-xl shadow-md bg-white"
  >
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col gap-4">
        <h1 class="!text-xl !font-bold text-left">
          Vistos buenos por institución
        </h1>
        <div id="charts-vb-types" class="m-auto">
          <slot name="ver"></slot>
          <apexchart
            class="mx-auto"
            v-if="series && series.length > 0"
            type="donut"
            height="250"
            :options="chartOptions"
            :series="series"
          />
        </div>
      </div>

      <vistos-buenos
        :data="vistos_buenos"
        :irADespachosPendientes="irVistosBuenos"
      >
        <template slot="ver">
          <button
            class="boton-ver"
            @click="
              irVistosBuenos({
                estado: true,
                text: 'Requiere Visto Bueno (CDA)',
                value: 'Si',
                filtro: 'visto_bueno',
              })
            "
          >
            Ver
          </button>
        </template>
      </vistos-buenos>
    </div>
  </div>
</template>
